<script>
    import { select } from "d3";
    let scrollables = {};
    
    function makeScrollable(name, scrollFn, initFn, stopFn) {
        var slides = select(".slides");
        var s = slides.selectAll(".scrollable-" + name).data([{}]);
        // If the div doesn't exist create it;
        s = s
            .enter()
            .append("div")
            .attr("class", "scrollable scrollable-" + name)
            .merge(s);
        // Default initFn
        initFn =
            initFn || function () {};
        // Default scrollFn
        scrollFn =
            scrollFn ||
            function (step) {
                s.select("text")
                    .transition()
                    .duration(1000)
                    .text("Step=" + step);
            };
        stopFn = stopFn || function() {};
        // Bind the this element
        initFn = initFn.bind(s.node());
        scrollFn = scrollFn.bind(s.node());
        stopFn = stopFn.bind(s.node());
        // Run the init code
        initFn();
        // Add the scrollable to the list
        scrollables[name] = {
            scroll: scrollFn,
            stop: stopFn,
        }; 
    }


    import { reveal } from "../stores/store.js";
    import { getScales } from "../utils.js";

    import { IRIS } from "@saehrimnir/dataset";
    import IrisGlyph from "./IrisGlyph.svelte";
    import * as druid from "@saehrimnir/druidjs/dist/druid.js";
    import * as hagrid from "@saehrimnir/hagrid/dist/hagrid.js";

    import { scaleOrdinal, schemeDark2 } from "d3";
    import * as d3 from "d3";
    import { onMount } from "svelte";
    import { fade, fly } from "svelte/transition";


    const W = 500;
    const M = 20;
    const range = [M, W - M];

    const c = scaleOrdinal(schemeDark2);

    function prepare_iris() {

        const umap = druid.UMAP.transform(IRIS.values, 15, 1, 1, 2, druid.euclidean, "cellar door");
        const {x, y} = getScales(umap, [range, range], true, d => d[0], d => d[1])
        
        const grid = hagrid.gridify(umap, "hilbert", {keepAspectRatio: true, pluslevel: 0});
        const {x: gx, y: gy} = getScales(grid, [range, range], true, d => d[0], d => d[1])

        return umap.map(([rx, ry], i) => [x(rx), y(ry), gx(grid[i][0]), gy(grid[i][1])])
    }
    const iris_umap = prepare_iris();

    

    $reveal.addEventListener("slidechanged", function (event) {
        var scrollable;

        if (d3.select(event.currentSlide).classed("scroll")) {
            if (
                d3.select(event.currentSlide).attr("step") &&
                d3.select(event.currentSlide).attr("scrollable")
            ) {
                scrollable = d3.select(event.currentSlide).attr("scrollable");
                
                d3.select(".scrollable-" + scrollable)
                    .style("visibility", "visible")
                    .style("opacity", 1);
                d3.select(".reveal").classed("scrolling", true);
                if (scrollable in scrollables) scrollables[scrollable].scroll(d3.select(event.currentSlide).attr("step"));
            }
        } else {
            // Not scrolling

            // Stop all scrollables
            for (var s in scrollables) {
                scrollables[s].stop();
            }
            d3.selectAll(".scrollable").style("visibility", "hidden").style("opacity", 0);
            d3.select(".reveal").classed("scrolling", false);
        }
    });

        

    let step;
    function doStep(event) {
        step = event
        if (step == "step 1") {
            glyph_size = 2;
        } else if (step == "step 1.05") {
            glyph_size = 1.25;
        } else if (step == "step 1.075") {
            glyph_size = 0.5;
        } else if (step == "step 1.1") {
            glyph_size = 2;
        }
    }

    let coil_umap;
    let coil_images = []

    let size_grid = 10;

    onMount(async () => {
        makeScrollable("demo", doStep);

        const coil_data = await d3.csv("./data/coil-100.csv", d3.autoType)
        coil_umap = coil_data.map(({UMAP_1, UMAP_2, filename}) => [+UMAP_1, +UMAP_2, filename])
        //console.log(coil_data)
        coil_images = coil_data.sort((a, b) => d3.ascending(a.filename, b.filename))
            //.filter(d => d.labels == "obj100_" || d.labels == "obj74_")
            .filter(d => parseInt(d.filename.slice(-3)) % 50 == 0)
        //console.log(coil_images)
        let {x, y} = getScales(coil_umap, [range, range], true);
        let coil_grid = hagrid.gridify(coil_umap, "hilbert", {keepAspectRatio: true});
        let {x: gx, y: gy} = getScales(coil_grid, [range, range], true);
        coil_umap = coil_umap.map(([dx, dy, filename], i) => [x(dx), y(dy), filename, gx(coil_grid[i][0]), gy(coil_grid[i][1])])
        size_grid = gx(1) - gx(0);
    })

    let glyph_size = 2
</script>

<section>
    <h2>Motivation</h2>
    <section>
        <p class="r-fit-text">high-dimensional data → dimensionality reduction → scatterplot</p>
        <div class="fragment">
            <p>enrich a scatterplot</p>
            <ul>
                <li>glyphs</li>
                <li>images</li>
            </ul>
        </div>
        <aside class="notes">
            with dimensionality reduction we are able to visualize high-dimensional data in scatterplots.
            data in a scatterplot is encoded by the position of the dots.
            the proximity of the dots encode the similarity of the high-dimensional data.✨
            A possible enrichment for scatterplots is replacing dots with meaningful glyphs or images for additional information.
        </aside>
    </section>

    <section class="scroll" scrollable="demo" step="step 0">
        <!-- <ul class="fade-in">
            <li>Iris-setosa</li>
            <li>Iris-virginica</li>
            <li>Iris-virginica</li>
        </ul> -->
        <img src="./images/setosa.jpg" alt="setosa" height=120 />
        <img src="./images/virginica.jpeg" alt="virginica" height=120 />
        <img src="./images/versicolor.jpg" alt="vesicolor" height=120 />
        <br>
        <svg class="fragment" width=150 height=150>
            <g transform="translate(75, 75)">
                <IrisGlyph index=-1 size=6/>
            </g>
        </svg>
        <aside class="notes">
            Here for instance is a scatterplot of a UMAP projection of the iris dataset.
            The iris dataset consists of measurements of 3 species of iris flowers, with 50 exemplars each.
            the four dimensions are the length and width of the sepals and the petals of the individual exemplars. ✨ 
            The values can be encodes as a glyph, which looks for instance like that.
        </aside>
    </section>
    <section class="scroll" scrollable="demo" step="step 1">
        <p>overlaps occur</p>
        <aside class="notes">
            with this size of the glyphs overlaps occur
        </aside>
    </section>
    <section class="scroll" scrollable="demo" step="step 1.05">
        <p>smaller glyph size<br>→<br>still overlaps</p>
        <aside class="notes">
            with slightly smaller glyphs overlaps still occur
        </aside>
    </section>
    <section class="scroll" scrollable="demo" step="step 1.075">
        <p>even smaller glyph size<br>→<br>unreadable</p>
        <aside class="notes">
            with even smaller glyphs the glyphs are not readable anymore and thus lost their purpose. 
            and still a few glyphs still overlap
        </aside>
    </section>
    <section class="scroll" scrollable="demo" step="step 1.1">
        <p>gridified<br>→<br>no overlaps</p>
        <aside class="notes">
            If the glyphs are aligned on a grid, no overlaps occur anymore.
        </aside>
    </section>
</section>

<section>
    <h2>Example</h2>

    <section>
        <h5>images instead of dots</h5>
        <div class="fragment">
            <p>coil-100 dataset</p>
            <div id="imagecontainer">
                {#each coil_images as {filename}, i}
                    <img style="margin: 0" src="./images/coil-100/{filename}.png" alt="coil{i}" />{#if (i+1) % 12 == 0}<br>{/if}
                {/each}
            </div>
        </div>
        <aside class="notes">
            When possible, a scatterplot can be enriched with images.  ✨ 
            The coil-100 dataset, for instance, consists of photos of objects at various rotations. 
        </aside>
    </section>
    <section class="scroll" scrollable="demo" step="step 2">
        <p>overlaps</p>
        <aside class="notes">
            projected with UMAP and the points drawn as their image, a lot of overlaps occur
        </aside>
    </section>
    <section class="scroll" scrollable="demo" step="step 2.1">
        <p>gridified<br>→<br>no overlaps</p>
        <aside class="notes">
            on the gridified version of the scatterplot no overlaps occur anymore.
        </aside>
    </section>
</section>

{#if step}
<div class="scrollable scrollable-demo">
    <div>
        <svg width={W} height={W}>
            {#if iris_umap}
                {#each [...iris_umap.entries()] as [i, [px, py, gx, gy]]}
                    {#if step == "step 0"}
                        <circle transition:fade
                            cx={px}
                            cy={py}
                            r="3"
                            fill={c(IRIS.labels[i])}
                        />
                    {:else if step == "step 1" || step == "step 1.05" || step == "step 1.075" || step == "step 1.1"}
                        <g class="animated" transition:fade
                            style="transform: {(step == "step 1" || step == "step 1.05" || step == "step 1.075") 
                                                    ? `translate(${px}px, ${py}px) rotate(${Math.random() * 120}deg) scale(${glyph_size})` 
                                                    : `translate(${gx}px, ${gy}px) rotate(${Math.random() * 120}deg) scale(${glyph_size})`}">
                                <IrisGlyph index={i} size={1} stroke="white" />
                        </g>
                    {/if}
                {/each}
            {/if}
            {#if coil_umap && step == "step 2" || step == "step 2.1"}
                <g transition:fade>
                    {#each [...coil_umap.entries()] as [i, [px, py, filename, gx, gy]]}
                        <g class="animated" style="transform: {step == "step 2" 
                                                    ? `translate(${px-10}px, ${py-10}px)` 
                                                    : `translate(${gx-10}px, ${gy-10}px)`}">
                            <image xlink:href="./images/coil-100/{filename}.png" width={size_grid}></image>
                        </g>
                    {/each}
                </g>
            {/if}
            
        </svg>
        <br />
        <small>UMAP projection of the {#if step == "step 2" || step == "step 2.1"}<em>COIL-100</em>{:else}<em>IRIS</em>{/if} dataset</small>
        {#if step == "step 1" || step == "step 1.05" || step == "step 1.075" || step == "step 1.1"}
            <br>
            <small transition:fade >Glyph size <input style="z-index: 9999; pointer-events: all" type="range" min=0.5 max=10 step=0.25 bind:value={glyph_size} /><span>{glyph_size}</span></small>
        {/if}
    </div>
</div>
{/if}

<style>
    .animated {
        transition: 1s ease-in-out transform;
    }
</style>